import { ResetPasswordFormContainer } from "@/areas/auth"

function PasswordReset() {
  return (
    <ResetPasswordFormContainer />
  )
}

export default PasswordReset
